import { render } from "./FormatColorHighlight.vue?vue&type=template&id=4528afe4"
import script from "./FormatColorHighlight.vue?vue&type=script&lang=js"
export * from "./FormatColorHighlight.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/FormatColorHighlight.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4528afe4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4528afe4', __exports__)) {
    api.reload('4528afe4', __exports__)
  }
  
  module.hot.accept("./FormatColorHighlight.vue?vue&type=template&id=4528afe4", () => {
    api.rerender('4528afe4', render)
  })

}


export default __exports__